<template>
    <div class="home u-pt1">
        <div class="section no-pad-bot" id="index-banner">
            <div class="container" v-if="authenticated">
                <div v-if="business_id != 0">
                    <form-admin></form-admin>
                </div>
                <div v-else-if="user_type == 'rocket'">
                    <rocket-admin></rocket-admin>
                </div>
            </div>
            <div class="container" v-else>
                <login-form></login-form>
            </div>
        </div>
    </div>
</template>

<script>


import {alerts} from '@/mixins/alerts.js';
import swal from 'sweetalert';
import Forms from '@/views/Forms.vue'
import Login from '@/views/Login.vue'
import RocketAdmin from '@/views/RocketAdmin.vue'

export default {
    name: 'home',
    data : function () {
        return {
            //
        };
    },
    components : {
        LoginForm : Login,
        FormAdmin : Forms,
        RocketAdmin : RocketAdmin
    },
    mounted : function () {
        let self = this;
    },
    computed : {
        user_type () {
            return this.$root.user_type;
        }
    },
    mixins : [alerts],
    methods:{
      //
    }
}
</script>

